'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";
import Loader from "@uw-it-sis/lib-react/lib/Loader";
import classnames from "classnames";

import {FaRegCalendarAlt} from "react-icons/fa";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";

import ScheduleBuilderPlan from "./ScheduleBuilderPlan";
import ScheduleBuilderForm from "./ScheduleBuilderForm";
import ScheduleBuilderOptions from "./ScheduleBuilderOptions";
import ReservedTimeFilter from "./ReservedTimeFilter";
import PinnedSchedules from "./PinnedSchedules";
import scheduleBuilderDetailsStore from './ScheduleBuilderDetailsStore';
import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import Spinner from "react-bootstrap/Spinner";

class ScheduleBuilderDetails extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = scheduleBuilderDetailsStore

        this.buildDoneComponent = this.buildDoneComponent.bind(this);
        this.buildScheduleOptions = this.buildScheduleOptions.bind(this);
    }

    componentDidMount() {
        this.store.mount(this.props.termId);
    }

    componentDidUpdate(prevProps) {
        if ( this.props.termId !== prevProps.termId ) {
            this.store.mount(this.props.termId);
        }
    }

    componentWillUnmount() {
        this.store.unmount();
    }

    buildScheduleOptions() {
        if ( !this.store.isBuildScheduleOptionsDisabled() ) {
            this.store.buildScheduleOptions();
        }
    }

    buildDoneComponent() {
        const loaderSpinner = <Spinner
            as="span"
            size="sm"
            animation="dots"
            role="status"
            aria-hidden="true"
        />;

        return (
            <Loader show={this.store.state === States.pending}
                    message={loaderSpinner}
                    contentBlur={1}
                    disableDefaultStyles>
                <Row className="mt-3">
                    <Col xs={12} lg={9} className="order-0">
                        <Card id="sb-selections" border="border" role="region" aria-label="Schedule Builder Options">
                            <Card.Body>
                                <ScheduleBuilderPlan />
                                <hr />
                                <h3 className="h4 mt-3">Section Filters</h3>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <ScheduleBuilderForm />
                                    </Col>
                                    <Col xs={12} md={6} className="mt-3 mt-md-0">
                                        <ReservedTimeFilter />
                                    </Col>
                                </Row>
                                <hr />
                                <Button onClick={this.buildScheduleOptions}
                                        className={classnames({"disabled": this.store.isBuildScheduleOptionsDisabled()})}
                                        aria-disabled={this.store.isBuildScheduleOptionsDisabled()}>
                                    <FaRegCalendarAlt aria-hidden="true" className="me-2" />Update Schedule Options
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={{span: 12, order: 2}} lg={{span: 3, order: 1}} className="mt-4 mt-lg-0">
                        <PinnedSchedules regDate={this.store.getRegistrationDate() ? this.store.getRegistrationDate().format("dddd, MMM D") : ""}/>
                    </Col>
                    <Col xs={{span: 12, order: 1}} lg={{span: 12, order: 2}} className="mt-4">
                        <ScheduleBuilderOptions termId={this.props.termId} regDate={this.store.getRegistrationDate() ? this.store.getRegistrationDate().format("dddd, MMM D") : ""}/>
                    </Col>
                </Row>
            </Loader>
        );
    }

    render() {
        // Use 'dots' animation for first time load of course section data
        let pendingComponent = "dots";
        // If data is already present, keeping showing sections list while add/remove sections action is taking place.
        if ( this.store.hasData() ) {
            pendingComponent = this.buildDoneComponent;
        }
        return (
            <SimpleState state={this.store.state}
                         doneComponentBuilder={this.buildDoneComponent}
                         pendingComponentBuilder={pendingComponent}
                         name="ScheduleBuilderDetails"/>
        )
    }
}

ScheduleBuilderDetails.propTypes = {
    termId: PropTypes.string.isRequired
}

export default observer(ScheduleBuilderDetails);